import DetailsSkeleton from '@/features/dashboard/bookingChanges/components/DetailsSkeleton.tsx';
import { ParticipantBillViewSkeleton } from '@/features/dashboard/bookingChanges/components/bill';

/**
 * `pendingComponent` ekranu uczestnika — trzy zakładki i rachunek jednej osoby
 * w kolumnie treści, bo wejście zawsze zaczyna się od „Informacji”.
 */
const ParticipantDetailsSkeleton = () => (
  <DetailsSkeleton tabCount={2}>
    <ParticipantBillViewSkeleton />
  </DetailsSkeleton>
);

export default ParticipantDetailsSkeleton;
